var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F1935C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05085 15.5591H10.8332V18.6191H9.95297L9.64714 18.0791C9.16974 18.533 8.57051 18.76 7.84945 18.76C7.34222 18.76 6.87477 18.6609 6.4471 18.4626C6.02441 18.2643 5.67631 17.9591 5.4028 17.547C5.13427 17.1348 5 16.6496 5 16.0913V15.6687C5 14.8339 5.28097 14.1817 5.8429 13.7122C6.40981 13.2374 7.12093 13 7.97626 13C8.63765 13 9.20455 13.1435 9.67698 13.4304C10.1494 13.7174 10.4701 14.1087 10.6392 14.6043L9.2145 15.0035C9.11007 14.7478 8.94597 14.547 8.72219 14.4009C8.50338 14.2548 8.24728 14.1817 7.95388 14.1817C7.55605 14.1817 7.22784 14.307 6.96925 14.5574C6.71066 14.8026 6.58137 15.1574 6.58137 15.6217V16.1383C6.58137 16.587 6.71066 16.9391 6.96925 17.1948C7.23281 17.4504 7.566 17.5783 7.9688 17.5783C8.58543 17.5783 9.02305 17.2574 9.28163 16.6157H8.05085V15.5591Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7558 18.6191V13.1409H13.2402L15.9181 16.24H15.933V13.1409H17.41V18.6191H15.9778L13.2477 15.4496H13.2328V18.6191H11.7558Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0304 18.6191L22.7246 17.8052H19.9647L19.6514 18.6191H18.0178L20.3973 13.0939H22.4188L24.761 18.6191H23.0304ZM20.4197 16.6391H22.2845L21.367 14.2209H21.3521L20.4197 16.6391Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05085 15.5591H10.8332V18.6191H9.95297L9.64714 18.0791C9.16974 18.533 8.57051 18.76 7.84945 18.76C7.34222 18.76 6.87477 18.6609 6.4471 18.4626C6.02441 18.2643 5.67631 17.9591 5.4028 17.547C5.13427 17.1348 5 16.6496 5 16.0913V15.6687C5 14.8339 5.28097 14.1817 5.8429 13.7122C6.40981 13.2374 7.12093 13 7.97626 13C8.63765 13 9.20455 13.1435 9.67698 13.4304C10.1494 13.7174 10.4701 14.1087 10.6392 14.6043L9.2145 15.0035C9.11007 14.7478 8.94597 14.547 8.72219 14.4009C8.50338 14.2548 8.24728 14.1817 7.95388 14.1817C7.55605 14.1817 7.22784 14.307 6.96925 14.5574C6.71066 14.8026 6.58137 15.1574 6.58137 15.6217V16.1383C6.58137 16.587 6.71066 16.9391 6.96925 17.1948C7.23281 17.4504 7.566 17.5783 7.9688 17.5783C8.58543 17.5783 9.02305 17.2574 9.28163 16.6157H8.05085V15.5591Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7558 18.6191V13.1409H13.2402L15.9181 16.24H15.933V13.1409H17.41V18.6191H15.9778L13.2477 15.4496H13.2328V18.6191H11.7558Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0304 18.6191L22.7246 17.8052H19.9647L19.6514 18.6191H18.0178L20.3973 13.0939H22.4188L24.761 18.6191H23.0304ZM20.4197 16.6391H22.2845L21.367 14.2209H21.3521L20.4197 16.6391Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9927 14.793V18.6504H25.9614V14.793H26.9927ZM26.9927 13.2002V13.8408H25.9614V13.2002H26.9927Z",
    fill: "#34656D",
    stroke: "#34656D",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGna);
export default __webpack_public_path__ + "static/media/gna.a0005206cd19c7fe6b63ba16eaa4b04f.svg";
export { ForwardRef as ReactComponent };